import React, { useEffect, useState } from 'react';
import { Dashboard } from './components/Dashboard';
import { AdPreferences } from './components/AdPreferences';
import { Editor } from './components/Editor';
import { currentProjectId } from './utils/navigation';

export const App: React.FC = () => {
  const [projectId, setProjectId] = useState<string | null>(() => currentProjectId());

  useEffect(() => {
    if (!window.location.hash) window.location.hash = '#/';
    const update = () => setProjectId(currentProjectId());
    window.addEventListener('hashchange', update);
    return () => window.removeEventListener('hashchange', update);
  }, []);

  return <>{projectId ? <Editor key={projectId} projectId={projectId} /> : <Dashboard />}<AdPreferences /></>;
};
